import Toast from './Toast'
import { useToasts } from './hooks'

export default function ToastContainer() {
  const [data, removeToast] = useToasts()

  return (
    <div className="fixed top-0 z-50 text-secondary right-4">
      {data.map((item) => (
        <Toast key={item.id} {...item} onClose={removeToast} />
      ))}
    </div>
  )
}
